import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('NEON_PULSE', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  ctx.globalAlpha = 1 - progress;
  ctx.shadowBlur = 50 * (1 - progress);
  ctx.shadowColor = determineColor(0, 1);
  ctx.strokeStyle = '#fff';
  ctx.lineWidth = 5;
  ctx.beginPath(); ctx.arc(e.pos.x, e.pos.y, e.radius + progress * 100, 0, Math.PI * 2);
  ctx.stroke(); ctx.shadowBlur = 0;
});
